export default __webpack_public_path__ + "static/media/SFProText-Light-1.8313687a.ttf";